<aside class="sidebar shadow-sm">

  <div class="sidebar-profile d-flex flex-column justify-content-center pt-2 pb-2">
    <!-- Profile with photo starts-->
    <!--<div class="picture-wrapper mb-2">
      <div class="user-picture m-auto">
        <label>
        <input type="file"  visbility="hidden" />
        <img src="./assets/img/user.jpg" class="img-fluid" alt="">
        </label>
      </div>
    </div>-->
    <div class="picture-wrapper mb-1">
      <div class="user-picture m-auto">
        <div id="upload_button">
        <label>
        <input type="file"  (change)="selectProfilePic($event,userProfile.userName)" visbility="hidden" />
          <img *ngIf="!userProfile.profilePicUrl" src="./assets/img/user.jpg" style="cursor:pointer" class="rounded-circle" alt="profile" height="60" width="60">
          <img *ngIf="userProfile.profilePicUrl" src="{{userProfile.profilePicUrl}}" style="cursor:pointer" class="rounded-circle" height="60" width="60" alt="profile">
        </label>
        </div>
      </div>
    </div>
    
    <div class="profile-details text-center pb-2">
      <p class="mb-0 name">{{userProfile.ownerName}}</p>
      <p class="mb-0 name" style="color:rgb(228, 133, 25);">{{userProfile.userRole}}</p>
      <span class="role">Last Login: {{userProfile.lastLogin | date: dateTimeFormat}}</span>
    </div>
    
    <!-- Profile with photo ends-->
    
  </div>
  <div class="sidebar-search pt-1 pb-1 pl-3 pr-3">
    <input type="search" class="form-control rounded-pill" name="search" placeholder="Search ...">
  </div>
  <nav class="sidebar-menu pt-1 pb-1" *ngIf="session">
    <ul class="menu-items">
      <li >
        <a href="#" routerLink="/superadmin/dashboard" routerLinkActive="active">
          <!--<i class="fas fa-home" style="font-size:18px"></i>-->
          <i class="material-icons" style="font-size:20px">dashboard</i>
          <span >Dashboard</span>
          <!--<span class="badge badge-warning rounded-0 text-dark p-1">NEW</span>-->
        </a>
      </li>
      
      <!--<li>
        <a href="#" routerLink="/superadmin/branch" routerLinkActive="active" [class.disabled]="!(subscriptionService.hasFeature('BRANCH') | async)">
          <i class="fas fa-hdd" style="font-size:20px"></i>
          <span>Branches</span>   
          &nbsp;<i *ngIf="!(subscriptionService.hasFeature('BRANCH') | async)" class="fa fa-lock" style="font-size:14px; color: red;"></i>       
        </a>
      </li>--> 
      <li>
        <a href="#" routerLink="/superadmin/branch" routerLinkActive="active" [class.disabled]="!featureJson.BRANCH">
          <i class="far fa-building" style="font-size:20px"></i>
          <span>Branches</span>   
          &nbsp;<i *ngIf="!featureJson.BRANCH" class="fa fa-lock" style="font-size:14px; color: red;"></i>       
        </a>
      </li>
      
      
      <!------------------Masterdata Menu Category----------------------->
      <li >
        <a routerLinkActive="active">
          <i class="fas fa-school" style="font-size:20px"></i>
          <span style="cursor: pointer;" (click)="toggleFlag('master',masterMenu)">Master Data</span>
          <i *ngIf="!masterMenu" (click)="toggleFlag('master',masterMenu)" class="fa fa-plus ml-auto" style="cursor: pointer; font-size:12px; color:rgb(228, 133, 25);"></i>
          <i *ngIf="masterMenu" (click)="toggleFlag('master',masterMenu)" class="fa fa-minus ml-auto" style="cursor: pointer; font-size:12px; color:rgb(228, 133, 25);"></i>
        </a> 
      </li>
      <span *ngIf="masterMenu">
        <!--<li>
          <a href="#" routerLink="/superadmin/branch" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Institute Branch**</span>        
          </a>
        </li>--> 
        <li>
          <a href="#" routerLink="/superadmin/session" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Sessions</span>        
          </a>
        </li>
        <li>
          <a href="#" routerLink="/superadmin/board" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Boards and Exams</span>        
          </a>
        </li>
        <li>
          <a href="#" routerLink="/superadmin/stream" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Streams</span>        
          </a>
        </li>
        <li>
          <a href="#" routerLink="/superadmin/classcourse" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Classe or Course</span>        
          </a>
        </li>
        <li>
          <a href="#" routerLink="/superadmin/section" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Section or Batch</span>        
          </a>
        </li>
        <li>
          <a href="#" routerLink="/superadmin/subject" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Subjects</span>        
          </a>
        </li> 
        <li>
          <a href="#" routerLink="/superadmin/grade" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Mark Grades</span>        
          </a>
        </li>
        
        <!--<li>
          <a href="#" routerLink="/superadmin/leavetype" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Leave Type**</span>        
          </a>
        </li>--> 
        <li>
          <a href="#" routerLink="/superadmin/holiday" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Holiday</span>        
          </a>
        </li> 
        <!--<li>
          <a href="#" routerLink="/superadmin/department" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Department</span>        
          </a>
        </li> 
        <li>
          <a href="#" routerLink="/superadmin/designation" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Designation</span>        
          </a>
        </li>-->
        <li>
          <a href="#" routerLink="/superadmin/template" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Templates</span>        
          </a>
        </li> 
        <!--<li >
          <a href="#" routerLink="/superadmin/template" routerLinkActive="active" [class.disabled]="false">
            <i class="fas fa-hdd" style="font-size:20px"></i>
            <span>Templates</span>&nbsp;
          </a>
        </li>-->
      </span>

      <!------------------Global Setting Menu Category----------------------->
      <li >
        <a routerLinkActive="active">
          <i class="fas fa-cog" style="font-size:20px"></i>
          <span style="cursor: pointer;" (click)="toggleFlag('setting',settingMenu)">Global Setting</span>
          <i *ngIf="!settingMenu" (click)="toggleFlag('setting',settingMenu)" class="fa fa-plus ml-auto" style="cursor: pointer; font-size:12px; color:rgb(228, 133, 25);"></i>
          <i *ngIf="settingMenu" (click)="toggleFlag('setting',settingMenu)" class="fa fa-minus ml-auto" style="cursor: pointer; font-size:12px; color:rgb(228, 133, 25);"></i>
        </a> 
      </li>
      <span *ngIf="settingMenu">  
        <li>
          <a href="#" routerLink="/superadmin/setting" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">General Setting</span>        
          </a>
        </li>
        <li>
          <a href="#" routerLink="/superadmin/setting/paymentgw" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Payment Gateway</span>        
          </a>
        </li>
        <li>
          <a href="#" routerLink="/superadmin/setting/emailgw" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Email Setting</span>        
          </a>
        </li>
        <li>
          <a href="#" routerLink="/superadmin/setting/cloud" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Cloud Provider</span>        
          </a>
        </li>
        <li>
          <a href="#" routerLink="/superadmin/setting/smsgw" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">SMS Setting</span>        
          </a>
        </li>
        <li>
          <a href="#" routerLink="/superadmin/setting/whatsappgw" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Whatsapp Setting</span>        
          </a>
        </li>
        <!--<li>
          <a href="#" routerLink="/superadmin/setting" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Modules</span>        
          </a>
        </li>
        <li>
          <a href="#" routerLink="/superadmin/useraccess" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">User Permission**</span>        
          </a>
        </li> -->
      </span>  
      <!------------------Payroll Master Menu Category----------------------->
      <li >
        <a routerLinkActive="active"><!--[class.disabled]="!(subscriptionService.hasFeature('FEE') | async)"-->
          <i class="fa fa-credit-card" style="font-size:20px"></i>
          <span style="cursor: pointer;" (click)="toggleFlag('feeMgmt',feeMgmtMenu)">Fee Management</span>
          <!--&nbsp;<i *ngIf="!(subscriptionService.hasFeature('FEE') | async)" class="fa fa-lock" style="font-size:14px; color: red;"></i>-->

          <i *ngIf="!feeMgmtMenu" (click)="toggleFlag('feeMgmt',feeMgmtMenu)" class="fa fa-plus ml-auto" style="cursor: pointer; font-size:12px; color:rgb(228, 133, 25);"></i>
          <i *ngIf="feeMgmtMenu" (click)="toggleFlag('feeMgmt',feeMgmtMenu)" class="fa fa-minus ml-auto" style="cursor: pointer; font-size:12px; color:rgb(228, 133, 25);"></i>
        </a> 
      </li>
      <span *ngIf="feeMgmtMenu">        
        <!--<li>
          <a href="#" routerLink="/user/leads" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Fee Group/Slab</span>        
          </a>
        </li>-->
        <li>
          <a href="#" routerLink="/superadmin/fee" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Fee Type</span>        
          </a>
        </li>
        <li>
          <a href="#" routerLink="/superadmin/fee/setup" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Fee Master/Assign</span>        
          </a>
        </li>
        <li>
          <a href="#" routerLink="/superadmin/fee/details" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Fee Details</span>        
          </a>
        </li>
        <!--<li>
          <a href="#" routerLink="/user/leads" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Fee Discount</span>        
          </a>
        </li>
        <li>
          <a href="#" routerLink="/user/leads" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Collect Fee/Update</span>        
          </a>
        </li>
        <li>
          <a href="#" routerLink="/user/leads" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Search Fee</span>        
          </a>
        </li>
        <li>
          <a href="#" routerLink="/user/leads" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Fee Carry Forward</span>        
          </a>
        </li>-->
        <li>
          <a href="#" routerLink="/user/leads" routerLinkActive="active" [class.disabled]="true">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Fee Reminder</span>        
          </a>
        </li>
      </span>
      <!------------------Payroll Master Menu Category----------------------->
      <li >
        <a routerLinkActive="active">
          <i class="fas fa-money-check-alt" style="font-size:20px"></i>
          <span style="cursor: pointer;" (click)="toggleFlag('payrollMgmt',payrollMgmtMenu)">Payroll Management</span>
          <i *ngIf="!payrollMgmtMenu" (click)="toggleFlag('payrollMgmt',payrollMgmtMenu)" class="fa fa-plus ml-auto" style="cursor: pointer; font-size:12px; color:rgb(228, 133, 25);"></i>
          <i *ngIf="payrollMgmtMenu" (click)="toggleFlag('payrollMgmt',payrollMgmtMenu)" class="fa fa-minus ml-auto" style="cursor: pointer; font-size:12px; color:rgb(228, 133, 25);"></i>
        </a> 
      </li>
      <span *ngIf="payrollMgmtMenu">        
        <li>
          <a href="#" routerLink="/superadmin/payroll/masterallowance" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Master Allownce</span>        
          </a>
        </li> 
        <li>
          <a href="#" routerLink="/superadmin/payroll/employeeallowance" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Employee Allownce</span>        
          </a>
        </li> 
        <li>
          <a href="#" routerLink="/superadmin/payroll/masterdeduction" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Master Deduction</span>        
          </a>
        </li> 
        <li>
          <a href="#" routerLink="/superadmin/payroll/employeededuction" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Employee Deduction</span>        
          </a>
        </li>
        <li>
          <a href="#" routerLink="/superadmin/payroll/salarystack" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Salary Stack</span>        
          </a>
        </li> 
        <li>
          <a href="#" routerLink="/superadmin/payroll/salary" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Process Payroll</span>        
          </a>
        </li>
      </span>
      <!------------------Accounting Menu Category----------------------->      
      <li >
        <a routerLinkActive="active">
          <i class="fas fa-hand-holding-usd" style="font-size:20px"></i>
          <span style="cursor: pointer;" (click)="toggleFlag('accounting',accountingMenu)">Accounting</span>
          <i *ngIf="!accountingMenu" (click)="toggleFlag('accounting',accountingMenu)" class="fa fa-plus ml-auto" style="cursor: pointer; font-size:12px; color:rgb(228, 133, 25);"></i>
          <i *ngIf="accountingMenu" (click)="toggleFlag('accounting',accountingMenu)" class="fa fa-minus ml-auto" style="cursor: pointer; font-size:12px; color:rgb(228, 133, 25);"></i>
        </a> 
      </li>
      <span *ngIf="accountingMenu">
        <li>
          <a href="#" routerLink="/superadmin/accounting/bankAcct" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Bank Account</span>        
          </a>
        </li>        
        <li>
          <a href="#" routerLink="/superadmin/accounting" routerLinkActive="active" [class.disabled]="true">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Income & Expense</span>        
          </a>
        </li>
        <li>
          <a href="#" routerLink="/superadmin/accounting/incomeHead" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Income Head</span>        
          </a>
        </li>
        <li>
          <a href="#" routerLink="/superadmin/accounting/expenseHead" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Expense Head</span>        
          </a>
        </li>
        <li>
          <a href="#" routerLink="/superadmin/accounting/income" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Add Income</span>        
          </a>
        </li> 
        <li>
          <a href="#" routerLink="/superadmin/accounting/expense" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Add Expense</span>        
          </a>
        </li>
        <li>
          <a href="#" routerLink="/superadmin/accounting/cashtrans" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Cash Transaction</span>        
          </a>
        </li>
        <li>
          <a href="#" routerLink="/superadmin/accounting/vendor" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Add Vendor</span>        
          </a>
        </li>        
      </span>
      <!------------------Library Menu Category----------------------->      
      <li >
        <a routerLinkActive="active">
          <i class="fas fa-book-open" style="font-size:20px"></i>
          <span style="cursor: pointer;" (click)="toggleFlag('library',libraryMenu)">Library Management</span>
          <i *ngIf="!libraryMenu" (click)="toggleFlag('library',libraryMenu)" class="fa fa-plus ml-auto" style="cursor: pointer; font-size:12px; color:rgb(228, 133, 25);"></i>
          <i *ngIf="libraryMenu" (click)="toggleFlag('library',libraryMenu)" class="fa fa-minus ml-auto" style="cursor: pointer; font-size:12px; color:rgb(228, 133, 25);"></i>
        </a> 
      </li>
      <span *ngIf="libraryMenu">
        <li>
          <a href="#" routerLink="/superadmin/library/book" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Books</span>        
          </a>
        </li>        
        <li>
          <a href="#" routerLink="/superadmin/library/member" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Member & Card</span>        
          </a>
        </li>
        <li>
          <a href="#" routerLink="/superadmin/library/cardHolder" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Issue Return Books</span>        
          </a>
        </li>
      </span>
      <!------------------Inventory Menu Category----------------------->      
      <li >
        <a routerLinkActive="active">
          <i class="far fa-object-group" style="font-size:20px"></i>
          <span style="cursor: pointer;" (click)="toggleFlag('inventory',inventoryMenu)">Inventory</span>
          <i *ngIf="!inventoryMenu" (click)="toggleFlag('inventory',inventoryMenu)" class="fa fa-plus ml-auto" style="cursor: pointer; font-size:12px; color:rgb(228, 133, 25);"></i>
          <i *ngIf="inventoryMenu" (click)="toggleFlag('inventory',inventoryMenu)" class="fa fa-minus ml-auto" style="cursor: pointer; font-size:12px; color:rgb(228, 133, 25);"></i>
        </a> 
      </li>
      <span *ngIf="inventoryMenu">
        <li>
          <a href="#" routerLink="/superadmin/inventory/category" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Category</span>        
          </a>
        </li>        
        <li>
          <a href="#" routerLink="/superadmin/inventory/item" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Items</span>        
          </a>
        </li>
        <li>
          <a href="#" routerLink="/superadmin/inventory/supplier" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Supplier</span>        
          </a>
        </li>
        <li>
          <a href="#" routerLink="/superadmin/inventory/store" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Store Detail</span>        
          </a>
        </li>
        <li>
          <a href="#" routerLink="/superadmin/inventory/stock" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Item Stock</span>        
          </a>
        </li>
        <li>
          <a href="#" routerLink="/superadmin/inventory/issueItem" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Issue Item</span>        
          </a>
        </li>
        <li>
          <a href="#" routerLink="/superadmin/inventory/saleItem" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Sales Order</span>        
          </a>
        </li>
      </span>
      <!------------------Reception Desk Menu Category----------------------->
      <li >
        <a routerLinkActive="active">
          <i class="fas fa-stream" style="font-size:20px"></i>
          <span style="cursor: pointer;" (click)="toggleFlag('crm',crmMenu)">Reception Desk</span>
          <i *ngIf="!crmMenu" (click)="toggleFlag('crm',crmMenu)" class="fa fa-plus ml-auto" style="cursor: pointer; font-size:12px; color:rgb(228, 133, 25);"></i>
          <i *ngIf="crmMenu" (click)="toggleFlag('crm',crmMenu)" class="fa fa-minus ml-auto" style="cursor: pointer; font-size:12px; color:rgb(228, 133, 25);"></i>
        </a> 
      </li>
      <span *ngIf="crmMenu">        
        <li>
          <a href="#" routerLink="/superadmin/enquiry" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Admission Enquiry</span>
          </a>
        </li>
        <li>
          <a href="#" routerLink="/superadmin/admission/crm" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Admissions CRM</span>
          </a>
        </li>
        <li>
          <a href="#" routerLink="/superadmin/admission/bulk" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Admission Bulk</span>
          </a>
        </li>
        <li>
          <a href="#" routerLink="/superadmin/enquiry/addBulk" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Campaign Data Upload</span>        
          </a>
        </li>
        <li>
          <a href="#" routerLink="/superadmin/enquiry/visitor" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Visitors</span>        
          </a>
        </li>
        <li>
          <a href="#" routerLink="/superadmin/enquiry/complain" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Complains</span>        
          </a>
        </li>
        <li>
          <a href="#" routerLink="/superadmin/enquiry/postal" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Postal</span>        
          </a>
        </li>
      </span>
      
      <!------------------AUTOMATIONS Menu Category----------------------->
      <li >
        <a routerLinkActive="active">
          <i class="fas fa-user-cog" style="font-size:20px"></i>
          <span style="cursor: pointer;" (click)="toggleFlag('student',studentMenu)">Students</span>
          <i *ngIf="!studentMenu" (click)="toggleFlag('student',studentMenu)" class="fa fa-plus ml-auto" style="cursor: pointer; font-size:12px; color:rgb(228, 133, 25);"></i>
          <i *ngIf="studentMenu" (click)="toggleFlag('student',studentMenu)" class="fa fa-minus ml-auto" style="cursor: pointer; font-size:12px; color:rgb(228, 133, 25);"></i>
        </a> 
      </li>
      <span *ngIf="studentMenu">  
        <li>
          <a href="#" routerLink="/superadmin/addStudent" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">New Student</span>        
          </a>
        </li>       
        <li>
          <a href="#" routerLink="/superadmin/students" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Student Details</span>        
          </a>
        </li>  
        
        <li>
          <a href="#" routerLink="/user/tracker" routerLinkActive="active" [class.disabled]="true">
            &nbsp;&nbsp;<i class="fa fa-cog" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Scores and Analytics</span>         
          </a>
        </li>
        <li>
          <a href="#" routerLink="/superadmin/studentdoc/certificate" routerLinkActive="active">
            &nbsp;&nbsp;<i class="fa fa-cog" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Transfer Certificate</span>         
          </a>
        </li>
        <li>
          <a href="#" routerLink="/superadmin/studentdoc/icard" routerLinkActive="active">
            &nbsp;&nbsp;<i class="fa fa-cog" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Identity Card</span>         
          </a>
        </li>
        <li>
          <a href="#" routerLink="/superadmin/studentdoc/admitcard" routerLinkActive="active">
            &nbsp;&nbsp;<i class="fa fa-cog" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Exam Admit Card</span>         
          </a>
        </li>
        <li>
          <a href="#" routerLink="/superadmin/studentdoc/award" routerLinkActive="active">
            &nbsp;&nbsp;<i class="fa fa-cog" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Award Certificate</span>         
          </a>
        </li>
        <li>
          <a href="#" routerLink="/superadmin/students/promote" routerLinkActive="active">
            &nbsp;&nbsp;<i class="fa fa-cog" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Class Promotion</span>         
          </a>
        </li>
        <li>
          <a href="#" routerLink="/superadmin/students/enable" routerLinkActive="active">
            &nbsp;&nbsp;<i class="fa fa-cog" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Enable Student</span>         
          </a>
        </li>
        <li>
          <a href="#" routerLink="/superadmin/students/past" routerLinkActive="active">
            &nbsp;&nbsp;<i class="fa fa-cog" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Old Students</span>         
          </a>
        </li>
      </span>
      <!------------------AUTOMATIONS Menu Category----------------------->
      <!------------------Student Attendance Menu Category----------------------->
      <li >
        <a routerLinkActive="active">
          <i class="fas fa-calendar-check" style="font-size:20px"></i>
          <span style="cursor: pointer;" (click)="toggleFlag('attendance',attendanceMenu)">Student Attendance</span>
          <i *ngIf="!attendanceMenu" (click)="toggleFlag('attendance',attendanceMenu)" class="fa fa-plus ml-auto" style="cursor: pointer; font-size:12px; color:rgb(228, 133, 25);"></i>
          <i *ngIf="attendanceMenu" (click)="toggleFlag('attendance',attendanceMenu)" class="fa fa-minus ml-auto" style="cursor: pointer; font-size:12px; color:rgb(228, 133, 25);"></i>
        </a> 
      </li>
      <span *ngIf="attendanceMenu">        
        <li>
          <a href="#" routerLink="/superadmin/attendance" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Attendance</span>        
          </a>
        </li>
        <li>
          <a href="#" routerLink="/superadmin/attendance/view" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">View Attendance</span>        
          </a>
        </li>
        <li>
          <a href="#" routerLink="/superadmin/attendance/view" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">QRCode Attendance</span>        
          </a>
        </li>
        
        <li>
          <a href="#" routerLink="/superadmin/leave" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Leave Requests</span>        
          </a>
        </li>
      </span>
      
      <!------------------Transport Menu Category----------------------->
      <li >
        <a routerLinkActive="active">
          <i class="fas fa-bus-alt" style="font-size:20px"></i>
          <span style="cursor: pointer;" (click)="toggleFlag('transport',transportMenu)">Transport</span>
          <i *ngIf="!transportMenu" (click)="toggleFlag('transport',transportMenu)" class="fa fa-plus ml-auto" style="cursor: pointer; font-size:12px; color:rgb(228, 133, 25);"></i>
          <i *ngIf="transportMenu" (click)="toggleFlag('transport',transportMenu)" class="fa fa-minus ml-auto" style="cursor: pointer; font-size:12px; color:rgb(228, 133, 25);"></i>
        </a> 
      </li>
      <span *ngIf="transportMenu">        
        <li>
          <a href="#" routerLink="/superadmin/vehicle" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Vehicle</span>        
          </a>
        </li>
        <li>
          <a href="#" routerLink="/superadmin/busroute" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Bus Route</span>        
          </a>
        </li>
        <li>
          <a href="#" routerLink="/superadmin/busroute/students" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Route Students</span>        
          </a>
        </li>
      </span>
      
      <!------------------AUTOMATIONS Menu Category----------------------->
      <!------------------Online Examination----------------------->
      <li >
        <a routerLinkActive="active" [class.disabled]="!featureJson.ONLINE_EXAM">
          <i class="fas fa-rss" style="font-size:20px"></i>
          <span style="cursor: pointer;" (click)="toggleFlag('test_exam',testMenu)">Online Exam</span>
          <i *ngIf="!testMenu" (click)="toggleFlag('test_exam',testMenu)" class="fa fa-plus ml-auto" style="cursor: pointer; font-size:12px; color:rgb(228, 133, 25);"></i>
          <i *ngIf="testMenu" (click)="toggleFlag('test_exam',testMenu)" class="fa fa-minus ml-auto" style="cursor: pointer; font-size:12px; color:rgb(228, 133, 25);"></i>
        </a> 
      </li>
      <span *ngIf="testMenu">        
        <li>
          <a href="#" routerLink="/superadmin/questionbank" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Question Bank</span>        
          </a>
        </li> 
        <li>
          <a href="#" routerLink="/superadmin/questionbank/bulk" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">QBank Bulk</span>        
          </a>
        </li>        
        <li>
          <a href="#" routerLink="/superadmin/onlineexam" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Online Exam</span>        
          </a>
        </li>
      </span>
      <!------------------Offline Examination----------------------->
      <li >
        <a routerLinkActive="active">
          <i class="fas fa-layer-group" style="font-size:20px"></i>
          <span style="cursor: pointer;" (click)="toggleFlag('offline_exam',offlineExamMenu)">Offline Exam</span>
          <i *ngIf="!offlineExamMenu" (click)="toggleFlag('offline_exam',offlineExamMenu)" class="fa fa-plus ml-auto" style="cursor: pointer; font-size:12px; color:rgb(228, 133, 25);"></i>
          <i *ngIf="offlineExamMenu" (click)="toggleFlag('offline_exam',offlineExamMenu)" class="fa fa-minus ml-auto" style="cursor: pointer; font-size:12px; color:rgb(228, 133, 25);"></i>
        </a> 
      </li>
      <span *ngIf="offlineExamMenu">        
        <li>
          <a href="#" routerLink="/superadmin/offlineexam" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Offline Exams</span>        
          </a>
        </li>        
        <li>
          <a href="#" routerLink="/superadmin/offlineexam/schedule" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Exam Schedules</span>        
          </a>
        </li>
        <li>
          <a href="#" routerLink="/superadmin/offlineexam/marksheet" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Marksheet</span>        
          </a>
        </li>
      </span>
      <!------------------Notificaton Menu Category----------------------->
      <li >
        <a routerLinkActive="active">
          <i class="fas fa-bullhorn" style="font-size:20px"></i>
          <span style="cursor: pointer;" (click)="toggleFlag('notification',notificationMenu)">Communications*</span>
          <i *ngIf="!notificationMenu" (click)="toggleFlag('notification',notificationMenu)" class="fa fa-plus ml-auto" style="cursor: pointer; font-size:12px; color:rgb(228, 133, 25);"></i>
          <i *ngIf="notificationMenu" (click)="toggleFlag('notification',notificationMenu)" class="fa fa-minus ml-auto" style="cursor: pointer; font-size:12px; color:rgb(228, 133, 25);"></i>
        </a> 
      </li>
      <span *ngIf="notificationMenu">        
        <li>
          <a href="#" routerLink="/superadmin/notice" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Notification</span>        
          </a>
        </li>   
        <li>
          <a href="#" routerLink="/superadmin/message/template" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Message Template</span>        
          </a>
        </li>     
        <li>
          <a href="#" routerLink="/superadmin/message/send" routerLinkActive="active">
            &nbsp;&nbsp;<i class="fas fa-shipping-fast" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Send Message</span>         
          </a>
        </li>        
        <li>
          <a href="#" routerLink="/superadmin/message/log" routerLinkActive="active">
            &nbsp;&nbsp;<i class="fa fa-cog" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Message Log</span>         
          </a>
        </li>
        
      </span>     
      <!------------------AUTOMATIONS Menu Category----------------------->
      <li >
        <a routerLinkActive="active">
          <i class="fas fa-sitemap" style="font-size:20px"></i>
          <span style="cursor: pointer;" (click)="toggleFlag('staff',staffMenu)">Human Resource</span>
          <i *ngIf="!staffMenu" (click)="toggleFlag('staff',staffMenu)" class="fa fa-plus ml-auto" style="cursor: pointer; font-size:12px; color:rgb(228, 133, 25);"></i>
          <i *ngIf="staffMenu" (click)="toggleFlag('staff',staffMenu)" class="fa fa-minus ml-auto" style="cursor: pointer; font-size:12px; color:rgb(228, 133, 25);"></i>
        </a> 
      </li>
      <span *ngIf="staffMenu">        
        <li>
          <a href="#" routerLink="/superadmin/staff" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Staff Directory</span>        
          </a>
        </li>
        <li>
          <a href="#" routerLink="/superadmin/staff/addStaff" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Add Staff</span>        
          </a>
        </li>
        <li>
          <a href="#" routerLink="/superadmin/department" routerLinkActive="active">
            &nbsp;&nbsp;<i class="fa fa-cog" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Department</span>         
          </a>
        </li>
        <li>
          <a href="#" routerLink="/superadmin/designation" routerLinkActive="active">
            &nbsp;&nbsp;<i class="fa fa-cog" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Designation</span>         
          </a>
        </li>
        <li>
          <a href="#" routerLink="/superadmin/leavetype" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Leave Type</span>        
          </a>
        </li> 
        <li>
          <a href="#" routerLink="/superadmin/leavetype/setup" routerLinkActive="active">
            &nbsp;&nbsp;<i class="fa fa-cog" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Leave Master</span>         
          </a>
        </li>
        <li>
          <a href="#" routerLink="/superadmin/staff/leave" routerLinkActive="active">
            &nbsp;&nbsp;<i class="fa fa-cog" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Leave Report</span>         
          </a>
        </li>
        <li>
          <a href="#" routerLink="/superadmin/staff/leave/history" routerLinkActive="active">
            &nbsp;&nbsp;<i class="fa fa-cog" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Leave History</span>         
          </a>
        </li>
        <li>
          <a href="#" routerLink="/superadmin/staff/attendance" routerLinkActive="active">
            &nbsp;&nbsp;<i class="fa fa-cog" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Attendance</span>         
          </a>
        </li>
        <li>
          <a href="#" routerLink="/superadmin/staff/attendance/report" routerLinkActive="active">
            &nbsp;&nbsp;<i class="fa fa-cog" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Attendance Report</span>         
          </a>
        </li>
        <li>
          <a href="#" routerLink="/superadmin/staffdoc/letter" routerLinkActive="active">
            &nbsp;&nbsp;<i class="fa fa-cog" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Letters</span>         
          </a>
        </li>
        <li>
          <a href="#" routerLink="/superadmin/staffdoc/icard" routerLinkActive="active">
            &nbsp;&nbsp;<i class="fa fa-cog" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Identity Card</span>         
          </a>
        </li>
        <li>
          <a href="#" routerLink="/superadmin/staff/enable" routerLinkActive="active">
            &nbsp;&nbsp;<i class="fa fa-cog" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Enable Staff</span>         
          </a>
        </li>
        <li>
          <a href="#" routerLink="/superadmin/staff/past" routerLinkActive="active">
            &nbsp;&nbsp;<i class="fa fa-cog" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Old Staffs</span>         
          </a>
        </li>
      </span>
      <!------------------AUTOMATIONS Menu Category----------------------->  
      <li >
        <a href="#" routerLink="/superadmin/parent" routerLinkActive="active">
          <i class="fas fa-user-friends" style="font-size:18px"></i>
          <span>Parents</span>         
        </a>
      </li>
      <!------------------AUTOMATIONS Menu Category----------------------->
      
      <li >
        <a routerLinkActive="active">
          <i class="fas fa-graduation-cap" style="font-size:20px"></i>
          <span style="cursor: pointer;" (click)="toggleFlag('academic',academicMenu)">Academics</span>
          <i *ngIf="!academicMenu" (click)="toggleFlag('academic',academicMenu)" class="fa fa-plus ml-auto" style="cursor: pointer; font-size:12px; color:rgb(228, 133, 25);"></i>
          <i *ngIf="academicMenu" (click)="toggleFlag('academic',academicMenu)" class="fa fa-minus ml-auto" style="cursor: pointer; font-size:12px; color:rgb(228, 133, 25);"></i>
        </a> 
      </li>
      <span *ngIf="academicMenu">        
        <li>
          <a href="#" routerLink="/superadmin/academic/chapter" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Chapters</span>        
          </a>
        </li>
        <li>
          <a href="#" routerLink="/superadmin/academic/topic" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Topics</span>        
          </a>
        </li> 
        <li>
          <a href="#" routerLink="/superadmin/academic/syllabus" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Syllabus Status</span>        
          </a>
        </li>
        <li>
          <a href="#" routerLink="/superadmin/academic/video" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Video Tutorial</span>        
          </a>
        </li>   
        <li>
          <a href="#" routerLink="/superadmin/timetable" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Time Table</span>        
          </a>
        </li> 
        <li>
          <a href="#" routerLink="/superadmin/homework" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Home Work</span>        
          </a>
        </li> 
        <li>
          <a href="#" routerLink="/user/leads" routerLinkActive="active" [class.disabled]="true">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Lession Plan</span>        
          </a>
        </li>    
      </span>
      
      <!------------------AUTOMATIONS Menu Category----------------------->
      <li >
        <a href="#" routerLink="/superadmin/liveclass/gmeet" routerLinkActive="active">
          <i class="fas fa-video" style="font-size:18px"></i>
          <span>GMeet Live Class</span>         
        </a>
      </li>
      <li >
        <a href="#" routerLink="/superadmin/liveclass/zoom" routerLinkActive="active">
          <i class="fas fa-video" style="font-size:18px"></i>
          <span>Zoom Live Class</span>         
        </a>
      </li>
      <!------------------Report Menu Category----------------------->
      <li >
        <a routerLinkActive="active">
          <i class="fas fa-chart-line" style="font-size:20px"></i>
          <span style="cursor: pointer;" (click)="toggleFlag('report',reportMenu)">Reports</span>
          <i *ngIf="!reportMenu" (click)="toggleFlag('report',reportMenu)" class="fa fa-plus ml-auto" style="cursor: pointer; font-size:12px; color:rgb(228, 133, 25);"></i>
          <i *ngIf="reportMenu" (click)="toggleFlag('report',reportMenu)" class="fa fa-minus ml-auto" style="cursor: pointer; font-size:12px; color:rgb(228, 133, 25);"></i>
        </a> 
      </li>
      <span *ngIf="reportMenu">        
        <li>
          <a href="#" routerLink="/user/leads" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Fee Payment Report</span>        
          </a>
        </li>
        <li>
          <a href="#" routerLink="/user/leads" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Student Performance</span>        
          </a>
        </li> 
        <li>
          <a href="#" routerLink="/user/leads" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Student Retention</span>        
          </a>
        </li>
        <li>
          <a href="#" routerLink="/user/leads" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Teacher Retention</span>        
          </a>
        </li>   
      </span>
      <!------------------Report Menu Category----------------------->

      <li >
        <a href="#" routerLink="/superadmin/sample" routerLinkActive="active" [class.disabled]="false">
          <i class="fas fa-hdd" style="font-size:20px"></i>
          <span>Samples</span>          
        </a>
      </li>
      <li >
        <a href="#" routerLink="/superadmin/sample/calendar" routerLinkActive="active">
          <i class="fas fa-calendar" style="font-size:20px"></i>
          <span>Calendar</span>          
        </a>
      </li>
      <li >
        <a href="#" routerLink="/superadmin/chart" routerLinkActive="active">
          <i class="fas fa-chart-pie" style="font-size:20px"></i>
          <span>Charts</span>          
        </a>
      </li>
      <li >
        <a href="#" routerLink="/superadmin/externalexam" routerLinkActive="active">
          <i class="fas fa-rss" style="font-size:20px"></i>
          <span>External Exam</span>          
        </a>
      </li>
      
      <li >
        <a routerLinkActive="active">
          <i class="fas fa-user-cog" style="font-size:20px"></i>
          <span style="cursor: pointer;" (click)="toggleFlag('aiagent',aiAgentMenu)">AI Agents</span>
          <i *ngIf="!aiAgentMenu" (click)="toggleFlag('aiagent',aiAgentMenu)" class="fa fa-plus ml-auto" style="cursor: pointer; font-size:12px; color:rgb(228, 133, 25);"></i>
          <i *ngIf="aiAgentMenu" (click)="toggleFlag('aiagent',aiAgentMenu)" class="fa fa-minus ml-auto" style="cursor: pointer; font-size:12px; color:rgb(228, 133, 25);"></i>
        </a> 
      </li>
      <span *ngIf="aiAgentMenu">  
        <li>
          <a href="#" routerLink="/superadmin/aiagent/chatbot" routerLinkActive="active">
            &nbsp;&nbsp;&nbsp;<i class="fas fa-tasks" style="font-size:17px"></i>
            <span style="color:rgb(228, 133, 25);">Enquiry Chatbot</span>        
          </a>
        </li>
      </span> 

      <li >
        <a href="#" routerLink="/user/sample" routerLinkActive="active" [class.disabled]="true">
          <i class="fa fa-tv" style="font-size:18px"></i>
          <span>Hostel Management</span>         
        </a>
      </li>
      <li >
        <a href="#" routerLink="/user/sample" routerLinkActive="active" [class.disabled]="true">
          <i class="fa fa-tv" style="font-size:18px"></i>
          <span>Alumni</span>         
        </a>
      </li>
      <li >
        <a href="#" routerLink="/user/sample" routerLinkActive="active" [class.disabled]="true">
          <i class="fa fa-tv" style="font-size:18px"></i>
          <span>Study Materials</span>         
        </a>
      </li>
      <li >
        <a href="#" routerLink="/user/sample" routerLinkActive="active" [class.disabled]="true">
          <i class="fa fa-tv" style="font-size:18px"></i>
          <span>Promo Codes</span>         
        </a>
      </li>
      <li >
        <a href="#" routerLink="/user/sample" routerLinkActive="active" [class.disabled]="true">
          <i class="fa fa-tv" style="font-size:18px"></i>
          <span>Event Gallery</span>         
        </a>
      </li>
      
    </ul>
    
    <!--<div class="menu-header mt-4 mb-4">
      Github Repo
    </div>
    <div class="view-source mb-3">
      <a href="https://github.com/azouaoui-med/lightning-admin-angular" target="_blank" class="btn btn-block btn-lightning rounded-0">View Source</a>
    </div>  --> 
  </nav>
</aside>